import React from 'react';
import { withTranslation } from 'react-i18next';
import ButtonWrapper from '../components/common/ButtonWrapper';
import { history } from '../store';
import { isEditor } from '../behavior/init/selectors';
import connect from 'react-redux/es/connect/connect';
import { compose } from 'redux';
import { getErrorMessage } from '../utils';
import i18n from '../i18n';
import useUser from '@behavior/init/getUserV2';
import { useTranslation } from 'react-i18next';

const ForbiddenPage = ({ showHomeButton, errorData }) => {
  const { user } = useUser();
  const { t } = useTranslation();
  let translationCode = getErrorMessage(errorData);

  return (
    <div>
      <h3>403 Forbidden</h3>
      <p>{t('message.error.403')}</p>
      {translationCode && i18n.exists(translationCode) && <p>{t(translationCode)}</p>}
      {showHomeButton && (
        <ButtonWrapper
          type="button"
          label={t('page.home.title')}
          key="backHomeButton"
          primary
          onClick={() => {
            history.push('/');
          }}
        />
      )}
      {!isEditor(user) && errorData != 'message.error.is.not.allowed.to.view.inentory' && (
        <ButtonWrapper
          type="button"
          label={t('menu.access.request')}
          key="toAccessRequestButton"
          primary
          onClick={() => {
            history.push('/accessRequest');
          }}
        />
      )}
    </div>
  );
};

ForbiddenPage.defaultProps = {
  showHomeButton: true,
};

const mapStateToProps = state => ({
  errorData: state.common.errorData,
});

export default compose(withTranslation(), connect(mapStateToProps, null))(ForbiddenPage);
